import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default function (el: Ref<HTMLElement | null | undefined>) {
  onMounted(() => {
    if (el.value) {
      disableBodyScroll(el.value, { reserveScrollBarGap: true })
    }
  })

  onBeforeUnmount(() => {
    if (el.value) {
      enableBodyScroll(el.value)
    }
  })
}
